// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs__HzVUY","tab":"tab__GHHLk"};